
export class Link {
    constructor(href, text){
      this.href = href.trim() || "";
      this.text = text.trim() || href.trim() || "";
    }
  
    get shortText(){
      const maxChar = 35;
      if(this.text.length > maxChar){
        return this.text.substr(0, maxChar) + "...";
      }
      else{
        return this.text;
      }
    }
    get shortHref(){
      const maxChar = 30;
      if(this.href.length > maxChar){
        return this.href.substr(0, maxChar) + "...";
      }
      else{
        return this.href;
      }
    }
  }